import { Injectable } from '@angular/core';
import { SurveyCategory } from 'src/app/shared/constants/survey-status';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { EngagementInsigtsService } from 'src/app/engagement-insights/engagement-insights.service';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { FileService } from 'src/app/shared/file-service/file.service';
import { SurveyInsightService } from '../survey-insight.service';
import { ExpenseSurveyDetailsService } from 'src/app/survey/expense-survey-details/service/expense-survey-details.service';
import { ProjectSurveyDetailsService } from 'src/app/survey/project-survey-details/project-survey-details.service';
import { SurveysFilteredSortedResponseDTO } from 'src/app/shared/models/response/survey-filtered-sorted-response-dto';
import { SurveysFilterSortDTO } from 'src/app/shared/models/surveys-filter';
import { ExportSurveyDto } from 'src/app/shared/models/exportSurveyDto.model';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { BulkDataProcessingRequestEnum } from 'src/app/shared/constants/enums/bulk-data-processing.enum';
import { BulkDataProcessingRequest } from 'src/app/shared/models/bulk-data-processing.model';
import { Params } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CLIENT_MANAGER_PARAM } from 'src/app/shared/impersonation/impersonation.service';

@Injectable({
    providedIn: 'root'
})
export class SurveyListService {
    constructor(private _engagementService: EngagementInsigtsService,
        private _sessionService: SessionService,
        private _fileService: FileService,
        private _surveyInsightService: SurveyInsightService,
        private _expenseSurveyDetailsService: ExpenseSurveyDetailsService,
        private _projectSurveyDetailsService: ProjectSurveyDetailsService,
        private _datepipe: DatePipe) { }

    public getSurveys(surveyType: number, filterSortDto: SurveysFilterSortDTO) {
        switch (surveyType) {
            case SurveyCategory.TimeSurvey:
                return this._engagementService.getSurveysFiltered(filterSortDto);
            case SurveyCategory.ExpenseSurvey:
                return this._engagementService.getExpenseSurveysFiltered(filterSortDto);
            case SurveyCategory.ProjectSurvey:
                return this._engagementService.getProjectSurveysFiltered(filterSortDto);
        }
    }

    public getSurveysData(surveyType: number, response: SurveysFilteredSortedResponseDTO) {
        switch (surveyType) {
            case SurveyCategory.TimeSurvey:
                return response.timeSurveyDetailFiltered;
            case SurveyCategory.ExpenseSurvey:
                return response.expenseSurveyDetailFiltered;
            case SurveyCategory.ProjectSurvey:
                return response.projectSurveyDetailFiltered;
        }
    }

    public getEmailSentDateDetails(surveyType: number, surveyId: number, engagementId: number) {
        switch (surveyType) {
            case SurveyCategory.TimeSurvey:
                return this._surveyInsightService.getSMEsEmailSentDateDetails(surveyId, engagementId);
            case SurveyCategory.ExpenseSurvey:
                return this._expenseSurveyDetailsService.getExpenseSMEsEmailSentDateDetails(surveyId, engagementId);
            case SurveyCategory.ProjectSurvey:
                return this._projectSurveyDetailsService.getProjectSMEsEmailSentDateDetails(surveyId, engagementId);
        }
    }

    public exportSelectedSurveys(surveyType: number, exportSurveyDto: ExportSurveyDto) {
        let url: string = "";
        switch (surveyType) {
            case SurveyCategory.TimeSurvey:
                url = API_URL.ExportSelectedSurveys;
                break;
            case SurveyCategory.ExpenseSurvey:
                url = API_URL.EXPENSESURVEY.DOWNLOADEXPENSESURVEYS;
                break;
            case SurveyCategory.ProjectSurvey:
                //url = url for download Project Surveys
                break;
        }
        return this._sessionService.downloadAsFile(url, exportSurveyDto)
    }
    
    public saveSelectedSurveys(surveyType: number, blob: Blob) {
        let fileName: string = "";
        switch (surveyType) {
            case SurveyCategory.TimeSurvey:
                fileName = 'Time Survey Export [';
                break;
            case SurveyCategory.ExpenseSurvey:
                fileName = 'Expense Survey Export - [';
                break;
            case SurveyCategory.ProjectSurvey:
                fileName = 'Project Survey Export - [';
                break;
            case BulkDataProcessingRequestEnum.CompletedTimeSurveyExport:
                fileName = 'Completed Time Survey Export [';
                break;
            case BulkDataProcessingRequestEnum.CompletedExpenseSurveyExport:
                fileName = 'Completed Expense Survey Export - [';
                break;
        }
        let currentDateTime = this._datepipe.transform((new Date), 'MM-dd-yyyy HH-MM-SS');
        fileName = fileName + this._sessionService.engagementName + '] - [' + currentDateTime + '].xlsx';
        this._fileService.saveBlobToFile(blob, `${fileName}`);
    }

    removeUnwantedCharcterAtEnd(inputString: string, characterToRemove: string): string {
        let charcterPosition = inputString.lastIndexOf(characterToRemove);
        if (inputString.lastIndexOf(characterToRemove) === inputString.length - 1) {
            inputString = inputString.substring(charcterPosition, 0);
        }
        return inputString;
    }

    addSpaceAfterCharcterToString(inputString: string, formatBycharcter: string): string {
        let stringSplitByCharacter: string[] = inputString.split(formatBycharcter);
        let formattedString = '';
        stringSplitByCharacter.forEach(stringItem => {
            if (stringItem.length > 0 && stringItem !== ' ') {
                formattedString = formattedString + stringItem + formatBycharcter + ' ';
            }
        });
        return formattedString.trim();
    }

    getEngAllActivities(engagementId: number) {
        return this._sessionService.apiUrlGet(
            API_URL.SURVEY.GETENGAGEMENTACTIVITIES + `?engagementId=${engagementId}`);
    }

    addEngProjectsUnderSurveys(engagementId: number, surveyIds: number[], projectIds: number[]) {
        let addEngProjectsInSurveys = { engagementId: engagementId, surveyIds: surveyIds, projectOrActivityIds: projectIds }
        return this._sessionService.apiUrlPost(API_URL.SURVEY.ADDENGPROJECTSUNDERSURVEYS, addEngProjectsInSurveys);
    }

    addEngActvitiesUnderSurveys(engagementId: number, surveyIds: number[], selectedActivityIds: number[]) {
        let addEngActivitiesInSurveys = { engagementId: engagementId, surveyIds: surveyIds, projectOrActivityIds: selectedActivityIds }
        return this._sessionService.apiUrlPost(API_URL.SURVEY.ADDENGAGEMENTACTIVITIESUNDERSURVEYS, addEngActivitiesInSurveys);
    }
    
    updateDueDateForSelectedSurveys(engagementId: number, surveyIds: number[], dueDate: string, surveyCategory: number) {
        let bulkUpdateDueDates = { engagementId: engagementId, surveyIds: surveyIds, dueDate: dueDate, surveyCategory: surveyCategory }
        return this._sessionService.apiUrlPost(API_URL.SURVEY.UPDATEDUEDATEFORSELECTEDSURVEYS, bulkUpdateDueDates);
    }
    
    fullyAllocateSurveys(engagementId: number, surveyIds: number[], selectedActivityId: number, IsMinimumValueChecked: boolean) {
        let addEngActivitiesInSurveys = { engagementId: engagementId, surveyIds: surveyIds, activityId: selectedActivityId, isMinimumValueChecked:IsMinimumValueChecked }
        return this._sessionService.apiUrlPost(API_URL.SURVEY.UpdateSurveysToFullyAllocated, addEngActivitiesInSurveys);
    }

    getSurveyUrl(clientId: number, engagementId: number, surveyType: string = 'time', surveyId: number = 0, viewAsParams: Params) {
        const viewAsParam = viewAsParams['viewAs'];
        if (!environment.production) {
            return viewAsParam
                ? `${environment.rcnSurveyUrl}${surveyType}?clientId=${clientId}&engagementId=${engagementId}&surveyId=${surveyId}&viewAs=${viewAsParam}`
                : `${environment.rcnSurveyUrl}${surveyType}?clientId=${clientId}&engagementId=${engagementId}&surveyId=${surveyId}`
        }
        const surveyUrl = viewAsParam
            ? `${environment.rcnUrl}${environment.rcnInternalSurvey}${surveyType}?clientId=${clientId}&engagementId=${engagementId}&surveyId=${surveyId}&viewAs=${viewAsParam}`
            : `${environment.rcnUrl}${environment.rcnInternalSurvey}${surveyType}?clientId=${clientId}&engagementId=${engagementId}&surveyId=${surveyId}`;
        return surveyUrl;
    }

    public getDropdownSettings(id: string, name: string) {
        return {
            singleSelection: false,
            defaultOpen: false,
            idField: id,
            textField: name,
            enableCheckAll: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
        };
    }

    public triggerBulkDataProcessing(exportSurveyDto: BulkDataProcessingRequest): Observable<any>{
        let url: string = "";
        switch (exportSurveyDto.requestType) {
            case BulkDataProcessingRequestEnum.TimeSurveyExport:
                url = API_URL.BULKDATAPROCESSING.TRIGGER_BULK_DATA_PROCESSING;
                break;
            case BulkDataProcessingRequestEnum.ExpenseSurveyExport:
                break;
            case BulkDataProcessingRequestEnum.ProjectSurveyExport:
                break;
        }
        return this._sessionService.apiUrlPost(url, exportSurveyDto);
    }

    public getBulkDataProcessingStatus(checkStatusDto: Array<BulkDataProcessingRequest>): Observable<any>{
        return this._sessionService.apiUrlPost(API_URL.BULKDATAPROCESSING.GET_BULK_DATA_PROCESSING_STATUS, checkStatusDto);
    }

    public DownloadExportedSurveys(requestDto: BulkDataProcessingRequest) {
        let url: string = "";
        switch (requestDto.requestType) {
            case BulkDataProcessingRequestEnum.TimeSurveyExport:
                url = API_URL.BULKDATAPROCESSING.DOWNLOAD_EXPORTED_DATA;
                break;
            case BulkDataProcessingRequestEnum.CompletedTimeSurveyExport:
                url = API_URL.BULKDATAPROCESSING.DOWNLOAD_EXPORTED_DATA;
                break;
            case BulkDataProcessingRequestEnum.CompletedExpenseSurveyExport:
                url = API_URL.BULKDATAPROCESSING.DOWNLOAD_EXPORTED_DATA;
                break;
            case BulkDataProcessingRequestEnum.ExpenseSurveyExport:
                break;
            case BulkDataProcessingRequestEnum.ProjectSurveyExport:
                break;
        }
        return this._sessionService.downloadAsFile(url, requestDto)
    }    

    getTimeSurveySMEEmailStatus(requestData){
        return this._sessionService.apiUrlPost(
        API_URL.SURVEY.GetSurveysSMEDefaultEmailDetails,requestData,
        );
    }

    getExpenseSurveySMEEmailStatus(requestData){
        return this._sessionService.apiUrlPost(
        API_URL.EXPENSESURVEY.GetExpenseSurveysSMEDefaultEmailDetails,requestData,
        );
    }

    public goToReconciliationPage(isClientManagerMode: boolean, smeDetails: { userId: number } | null, engagementId: number, clientId: number) {
        const viewAsParams = this.getViewAsParam(isClientManagerMode, smeDetails);        
        location.assign(this.getReconcileSurveyUrl('time/reconcile', engagementId, viewAsParams, clientId));
    }

    getViewAsParam(isClientManagerMode: boolean, smeDetails: { userId: number } | null): Params {
        if (isClientManagerMode) {
            return {
                viewAs: CLIENT_MANAGER_PARAM,
            }
        } else if (smeDetails) {
            return {
                viewAs: smeDetails.userId,
            }
        } else {
            return {}
        }
      }
    
    getReconcileSurveyUrl(action: string, engagementId: number = 0, viewAsParams: Params, clientId: number) {
        const viewAsParam = viewAsParams['viewAs'];
        if (!environment.production) {
            return viewAsParam
                ? `${environment.rcnSurveyUrl}${action}?clientId=${clientId}&engagementId=${engagementId}&viewAs=${viewAsParam}`
                : `${environment.rcnSurveyUrl}${action}?clientId=${clientId}&engagementId=${engagementId}`
        }
        const surveyUrl = viewAsParam
            ? `${environment.rcnUrl}${environment.rcnInternalSurvey}${action}?clientId=${clientId}&engagementId=${engagementId}&viewAs=${viewAsParam}`
            : `${environment.rcnUrl}${environment.rcnInternalSurvey}${action}?clientId=${clientId}&engagementId=${engagementId}`;
        return surveyUrl;
        }
}
